import { useGetSnoozeByDeviceIdQuery } from '../features/Timeline/timelineApi';
// eslint-disable-next-line @typescript-eslint/naming-convention
import React from 'react';
export const useCountdownTimer = (deviceId: string, currentOrgId: string, skip = false): any => {
    const [time, setTime] = React.useState(0);

    const { data: snoozeData, refetch }: any = useGetSnoozeByDeviceIdQuery(
        { deviceId },
        { skip: !deviceId || !currentOrgId || skip }
    );

    const startSnoozeTimer = (milliseconds: number): void => {
        setTimeout(() => {
            refetch();
        }, milliseconds);
    };

    React.useEffect(() => {
        if (snoozeData?.data?.duration > 0)
            startSnoozeTimer(snoozeData?.data?.duration + snoozeData?.data?.snoozedAt - Date.now());
    }, [snoozeData]);

    React.useEffect(() => {
        let timer: any;
        setTime(
            snoozeData?.data?.duration > 0
                ? Math.floor((snoozeData?.data?.duration + snoozeData?.data?.snoozedAt - Date.now()) / 1000)
                : 0
        );
        if (snoozeData?.data?.duration > 0) {
            timer = setInterval(() => {
                setTime((prevTime: any) => {
                    if (prevTime === 0) {
                        clearInterval(timer);
                        return prevTime;
                    }
                    return prevTime - 1;
                });
            }, 1000);
        }
        // Clean up timer when component unmounts
        return (): any => clearInterval(timer);
    }, [snoozeData]); // Run effect whenever initialTime changes

    return {
        hours: Math.floor(time / 3600),
        minutes: Math.floor((time % 3600) / 60),
        seconds: time % 60,
        isSnoozed: Boolean(snoozeData?.data?.duration),
    };
};
